import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {ButtonIcon} from 'ac_ui'
import {acPreset1, acPreset2, acPreset3, acTaskList, acTheory} from 'ac-icon'
import classNames from 'classnames'
import {IReduxState} from '../../../../redux/types/IReduxState'
import {ComponentEnum} from '../../componentsRegistry/Registry'
import {taskActions} from '../../redux/actions'
import {UserDto} from 'learndb-share'

const TaskEditorDrawer: React.FC = () => {
  const taskDispatch = useDispatch()

  const user = useSelector<IReduxState, UserDto | undefined>((state) => state.auth?.user)
  const userAnonymous = useSelector<IReduxState, UserDto | undefined>((state) => state.auth?.userAnonymous)

  let windowStyle = 0
  if (user && user.setting) {
    windowStyle = user.setting.windowStyle
  } else if (userAnonymous && userAnonymous.setting) {
    windowStyle = userAnonymous.setting.windowStyle
  }

  const isDrawerModalOpen = useSelector<IReduxState, boolean>((state) => state.task?.isDrawerModalOpen)
  const drawerModalComponentId = useSelector<IReduxState, ComponentEnum>((state) => state.task?.drawerModalComponentId)

  const openModal = (componentId): void => {
    const isOpen = componentId !== drawerModalComponentId || !isDrawerModalOpen
    taskDispatch(
      taskActions.setState({
        isDrawerModalOpen: isOpen,
        drawerModalComponentId: isOpen && componentId,
      }),
    )
  }

  const getIconWindowStyle = (): string => {
    if (windowStyle === 1) {
      return acPreset2
    } else if (windowStyle === 2) {
      return acPreset3
    } else {
      return acPreset1
    }
  }

  const css = classNames('task-editor-drawer', {
    'border-right': isDrawerModalOpen,
  })

  return (
    <nav className={css}>
      <ul>
        <li>
          <ButtonIcon
            iconPath={acTheory}
            isActive={ComponentEnum.theory === drawerModalComponentId && isDrawerModalOpen}
            title={'Теория'}
            onClick={() => {
              openModal(ComponentEnum.theory)
            }}
          />
          <span className={'visually-hidden'}>Теория</span>
        </li>
        <li>
          <ButtonIcon
            iconPath={acTaskList}
            isActive={ComponentEnum.taskList === drawerModalComponentId && isDrawerModalOpen}
            title={'Список уроков'}
            onClick={() => {
              openModal(ComponentEnum.taskList)
            }}
          />
          <span className={'visually-hidden'}>Список уроков</span>
        </li>
        <li>
          <ButtonIcon
            iconPath={getIconWindowStyle()}
            isActive={ComponentEnum.editorSetting === drawerModalComponentId && isDrawerModalOpen}
            title={'Настройки редактора'}
            onClick={() => {
              openModal(ComponentEnum.editorSetting)
            }}
          />
          <span className={'visually-hidden'}>Настройки редактора</span>
        </li>
      </ul>
    </nav>
  )
}

export {TaskEditorDrawer}
